<template>
    <div id="loadingPage" class="backInfoMain2">

        <b-container class="bv-example-row" style="height:AUTO;border:0px solid rgb(164, 164, 169)"> 
            <br/>
            <b-progress 
                striped
                :value="value" 
                :max="max" 
                :precision="2" 
                show-progress 
                animated>
            </b-progress>

            <!-- <pre>{{ isLoading }} - {{ value }}</pre> -->
            <!-- <b-button class="mx-2"
                  @click="clearData()"
              >
                <div>Clear Data</div>
            </b-button>
            <b-button class="mx-2"
                  @click="chargerData()"
              >
                <div>Fetch Data</div>
            </b-button>
            <div class="bv-example-row m-2" style="height:400px;overflow-y:auto;border:1px solid rgb(234, 234, 237)"> 
                <pre>{{ payload }}</pre>
            </div>  -->
        </b-container>

    </div>
</template>

<script>

import {mapGetters} from 'vuex'
import {dataService} from '@/services'
import store from '@/store'
//import SocketioService from '@/plugins/socket/socketio.service.js'
export default{
    name: "ficheContactFournisseur",
    components: {


    },
    data() {
        return{
            isLoading : false,
            pSize: this.$store.getters.getPageSize, //Taille des section droite/gauche
            value: 0,
            max: 100
        }
    },
    methods: {
        /**
         * Charge les données 
         */
         getData() {
            this.value = 1
            this.isLoading = true

            //Configuration pour calculer le % des données telechargées
            const config = {
                onDownloadProgress: (progressEvent) => {
                    var percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    this.value = percentCompleted
                },
            }

            //Appeler le service des données
            dataService.fetchData(config)
            .then(() => {
                this.isLoading = false //Une fois les données chargées locallement, on desactive le flag 
            })
            .then(() => {
                //Redirection vers la page des clients
                setTimeout(() => {
                    //this.$router.push({name: 'clientAccount' })
                    this.$router.push({name: 'department' })
                },2000)
            })
            .catch((error) => {
                alert('error : '+error)
            });
        },
        clearData() {
            this.value = 0
            dataService.clearData()
        },
    },
    beforeCreate() {

    },
    beforeMount() {

    },

 //------------------------------------------------------------------------------------------------
    computed: {
        ...mapGetters(['getAllData']),
        payload : () => store.getters.getAllData,
    },
//------------------------------------------------------------------------------------------------
    mounted() {
        this.getData()
    },
//------------------------------------------------------------------------------------------------
    watch: {
        
    }
}
</script>

<style lang="scss" scoped>

</style>